import React, { useEffect } from "react";
import { Box, Button, Typography } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  approveRequestGuest,
  deleteRequestGuest,
  fetchRequestGuests,
} from "redux/actions/requestGuest";
import { DateTime } from "luxon";
import { FORMAT_TYPE } from "utils/DateTimeUtils";

const RequestGuest = () => {
  const { t } = useTranslation("requestGuest");
  const dispatch = useDispatch();
  const companyId = useSelector((state) => state.account.staff.companyId);
  const requestGuests = useSelector((state) => state.requestGuest);

  useEffect(() => {
    dispatch(fetchRequestGuests(companyId));
  }, [companyId]);

  const onClickApprove = (requestGuestId: number) => {
    dispatch(approveRequestGuest(companyId, requestGuestId));
  };

  const onClickDelete = (requestGuestId: number) => {
    dispatch(deleteRequestGuest(companyId, requestGuestId));
  };

  return (
    <Box display={"flex"} flexDirection={"column"} padding={4}>
      <Typography variant={"h4"} style={{ margin: "16px 0" }}>
        {t("page_title")}
      </Typography>
      <Box display={"flex"}>
        {requestGuests.length === 0 && (
          <Typography>{t("no_requests")}</Typography>
        )}
        {requestGuests.map((requestGuest) => (
          <Box
            display={"flex"}
            border={1}
            style={{ borderRadius: "10px", padding: "16px" }}
            key={requestGuest.requestGuestId}
            alignItems={"flex-end"}
          >
            <Box display={"flex"} flexDirection={"column"}>
              <Typography style={{ fontWeight: "bold", fontSize: "16px" }}>
                {DateTime.fromJSDate(requestGuest.createdAt).toFormat(
                  FORMAT_TYPE.DATE_TIME
                )}
              </Typography>
              <Typography style={{ marginTop: "8px" }}>
                {t("name_label")}
                {requestGuest.name}
              </Typography>
              <Typography style={{ marginTop: "8px" }}>
                {t("tel_label")}
                {requestGuest.tel}
              </Typography>
              <Typography style={{ marginTop: "8px" }}>
                {t("email_label")}
                {requestGuest.email}
              </Typography>
            </Box>
            <Box display={"flex"} flexDirection={"column"} marginLeft={2}>
              <Box>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => onClickDelete(requestGuest.requestGuestId)}
                >
                  {t("delete")}
                </Button>
              </Box>
              <Box marginTop={1}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => onClickApprove(requestGuest.requestGuestId)}
                >
                  {t("approve")}
                </Button>
              </Box>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};
export default RequestGuest;
